export default __webpack_public_path__ + "static/media/p6.ac58ec35.PNG";